import { createFileRoute } from "@tanstack/react-router";
import { DownloadPage } from "@/pages/download";
import { head, loader } from "@/pages/download.meta";

export const Route = createFileRoute("/$locale/download")({
  loader,
  head,
  component: DownloadPage,
});
